module.exports = __webpack_public_path__ + "static/media/chevron-double-left.50d40419.svg";